import { useScale } from "hooks/size";
import { useSoundStore } from "utils/sound-store";
import { VolumeControl as VolumeControlComponent } from "./VolumeControl";

export const VolumeControl = () => {
  const { scale } = useScale();
  const toggleVolume = useSoundStore((store) => store.toggleVolume);
  const volume = useSoundStore((store) => store.volume);

  return (
    <VolumeControlComponent 
      scale={scale}
      volume={volume}
      onToggleVolume={toggleVolume}
    />
  );
};
